export const generateCSVData = (): string[][] => {
    return [
        ['Batch Code*','Plate Count*','Plate Type*','Expiry Date*','Manufacturing date*','Manufacturer Details*','Batch GRN*','Lot Size*','Visual Inspection Flag*'],
        ['BatchABC', '12', 'SCDA 55mm','31-12-2025', '01-01-2025','Test', 'GRN45676', '3', 'yes'],
        ['BatchABD', '12', 'SCDA 90mm','31-12-2025', '01-01-2025','Test', 'GRN45677', '4', 'yes'],
        ['BatchABC', '12', 'DEY 55mm','31-12-2025', '01-01-2025','Test', 'GRN45678', '5', 'yes'],
        ['BatchABD', '12', 'RCA 55mm','31-12-2025', '01-01-2025','Test', 'GRN45679', '6', 'yes'],
        ['BatchABC', '12', 'DEY 90mm','31-12-2025', '01-01-2025','Test', 'GRN45680', '7', 'yes'],
        ['BatchABD', '12', 'RCA 90mm','31-12-2025', '01-01-2025','Test', 'GRN45681', '8', 'yes']
        
    ];
};


// ['BATCH NUMBER', 'SERIAL NUMBER PREFIX', 'RANGE_FROM', 'PLATE COUNT', 'PLATE_TYPE', 'EXPIRY DATE', 'MANUFACTURING DATE', 'MANUFACTURER DETAILS'],
// ['B10001', 'MPATS PL', '277', '5', '90mm', '13-09-2024', '01-12-2023', 'Sample'],
// ['B10001', 'MPATS PL', '278', '5', '90mm', '13-09-2024', '01-12-2023', 'Sample']

